import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckIcon, XIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-olive-dark text-white relative overflow-hidden" data-id="element-95">
      <div className="absolute inset-0 bg-brand-olive/20 blur-[100px] rounded-full max-w-3xl mx-auto" data-id="element-96" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 sm:mb-10" data-id="element-98">
          <h2 className="text-xl sm:text-4xl font-serif font-bold mb-4 sm:mb-6" data-id="element-99">
            Vuoi continuare ad improvvisare ogni sera — o vuoi finalmente un
            metodo?
          </h2>
        </motion.div>

        {/* Final Comparison Table */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 sm:p-6 mb-6 sm:mb-10 border border-white/20" data-id="element-100">
          <div className="grid grid-cols-[1fr_auto_auto] gap-2 sm:gap-4 mb-3 sm:mb-4 text-xs sm:text-sm font-bold border-b border-white/20 pb-2" data-id="element-101">
            <div data-id="element-102"></div>
            <div className="text-center px-2" data-id="element-103">📦 COMPLETO</div>
            <div className="text-center px-2 text-brand-gold" data-id="element-104">⭐ PREMIUM</div>
          </div>

          {[{
          label: '6 Tomi Metodo Mediterraneo™',
          c: true,
          p: true
        }, {
          label: 'Piano Alimentare 30 Giorni',
          c: true,
          p: true
        }, {
          label: 'Lista della Spesa Premium',
          c: true,
          p: true
        }, {
          label: 'Guida Snack & Dessert Healthy',
          c: true,
          p: true
        }, {
          label: 'Guida Anti-Gonfiore',
          c: true,
          p: true
        }, {
          label: 'Metodo Reset 21 Giorni',
          c: false,
          p: true
        }].map((row, i) => <div key={i} className="grid grid-cols-[1fr_auto_auto] gap-2 sm:gap-4 py-2 border-b border-white/10 text-xs sm:text-sm" data-id="element-105">
              <div className="text-gray-200" data-id="element-106">{row.label}</div>
              <div className="flex justify-center w-16 sm:w-24" data-id="element-107">
                {row.c ? <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" data-id="element-108" /> : <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white/30" data-id="element-109" />}
              </div>
              <div className="flex justify-center w-16 sm:w-24" data-id="element-110">
                {row.p ? <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold" data-id="element-111" /> : <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white/30" data-id="element-112" />}
              </div>
            </div>)}

          <div className="grid grid-cols-[1fr_auto_auto] gap-2 sm:gap-4 pt-3 sm:pt-4 text-xs sm:text-sm font-bold" data-id="element-113">
            <div className="text-gray-300 uppercase" data-id="element-114">Prezzo Oggi</div>
            <div className="text-center w-16 sm:w-24" data-id="element-115">€19,90</div>
            <div className="text-center w-16 sm:w-24 text-brand-gold text-base sm:text-lg" data-id="element-116">
              €27,90
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-117">
          <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full sm:w-auto min-w-0 sm:min-w-[300px] mb-4 sm:mb-6" data-id="element-118">
            🚀 SÌ, VOGLIO IL SISTEMA PREMIUM RESET — €27,90
          </CTAButton>

          <div className="flex justify-center gap-2 sm:gap-3 text-gray-300 font-bold text-[11px] sm:text-sm mb-4 sm:mb-6" data-id="element-119">
            <span data-id="element-120">⚡ Accesso Immediato</span>
            <span data-id="element-121">•</span>
            <span data-id="element-122">🛡️ Garanzia 7 Giorni</span>
          </div>

          <p className="text-xs sm:text-sm text-gray-400" data-id="element-123">
            oppure inizia con il{' '}
            <a href="https://italia.kitonline.shop/cart/44759694901383:1" className="text-white underline hover:text-brand-gold" data-id="element-124">
              Pacchetto Completo — €19,90
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}